/**
 * window.Drupal.t polyfill
 * @param str
 */
if (!window.Drupal) {
  window.Drupal = {
    t: (str) => str,
  };
}

const ThematicCardTranslate = {
  thematic_card_button: window.Drupal.t('TC: Consulter'),
  thematic_card_default_title: window.Drupal.t('TC: Carte thématique'),
  thematic_card_card_mode: window.Drupal.t('TC: Mode carte'),
  thematic_card_card_mode_mobile: window.Drupal.t('TC: Mode carte'),
  thematic_card_page_profonde_ps: window.Drupal.t('TC: Ce professionnel de santé est présent dans les cartes thématiques suivantes'),
  thematic_card_page_profonde_health_institution: window.Drupal.t('TC: Cet établissement de santé est présent dans les cartes thématiques suivantes'),
  thematic_card_page_profonde_care_deal: window.Drupal.t('TC: Cette offre de santé est présent dans les cartes thématiques suivantes'),
  thematic_card_display_more: window.Drupal.t('TC: Afficher plus'),
  thematic_card_mode_list: window.Drupal.t('TC: Afficher mode liste'),
  thematic_card_mode_list_mobile: window.Drupal.t('TC: mode liste'),
  thematic_card_mode_map: window.Drupal.t('TC: Afficher mode map'),
  thematic_card_return_to_list: window.Drupal.t('TC: Revenir à toute la liste'),
  thematic_card_filter_label: window.Drupal.t('TC: Filter par :'),
  thematic_card_filter_select_plus: window.Drupal.t('TC: plus de filtres '),
  thematic_card_filter_cta_popin: window.Drupal.t('TC: tous les filtres '),
  thematic_card_filter_cta_rwd: window.Drupal.t('TC: Filtres et localisation'),
  thematic_card_no_result: window.Drupal.t('TC: N’hésitez pas également à élargir votre recherche'),
  thematic_card_no_result_inArea: window.Drupal.t('TC: Cette carte ne couvre pas le lieu indiqué dans votre recherche'),
  thematic_card_too_many_result: window.Drupal.t('TC: La carte thématique cible un périmètre trop important, le mode "Carte" n\'est plus disponible à partir de 100 000 résultats.'),
  popin: {
    close_text: window.Drupal.t('TC: Ferme le modal'),
    maj_text: window.Drupal.t('TC: Mise à jour le'),
    show_moins_text: window.Drupal.t('TC: Afficher moins'),
    show_plus_text: window.Drupal.t('TC: Afficher plus'),
    filter_titre_text: window.Drupal.t('TC: filtres et localisation'),
    acceder_la_text: window.Drupal.t('TC: accéder à la'),
    tout_effacer_text: window.Drupal.t('TC: tout effacer'),
    titre_recherche_region: window.Drupal.t('TC: Préciser un lieu'),
    map: window.Drupal.t(' carte'),
    list: window.Drupal.t(' liste'),
    no_location_selected: window.Drupal.t('TC: Aucun lieu sélectionné'),

  },

};

export default ThematicCardTranslate;
